import React, { useEffect, useState } from 'react'
import { connect, useDispatch } from 'react-redux';
import { Col, Input, Row, Table } from 'reactstrap';
import swal from "sweetalert";
import Select from "react-select";
import { api } from '../../../../utils/api';
import { logout } from '../../../../store/actions/AuthActions';
import LoadingV3 from '../../../components/Loading/LoadingV3';
import { translate } from '../../../../utils/translate';
import { FaRegEdit, FaSpinner, FaTrashAlt } from 'react-icons/fa';
import { checkType, deepCopyArray } from '../../../../utils/function';
import { arrField, configTypeList, customRankStatus, numField, rateTypeList } from '../../../../utils/config';
import customSelectStyles from '../../SelectStyle';
import NotFound from '../../Common/NotFound';
import { Modal } from 'react-bootstrap';

function Rank(props) {
    const dispatch = useDispatch();
    const settingKey = "rcfx_rank";
    const [info, setInfo] = useState([])
    const [allSetting, setAllSetting] = useState(null)
    const [loadingData, setLoadingData] = useState(false)
    const [loading, setLoading] = useState(false)
    const [formData, setFormData] = useState([])
    const [configData, setConfigData] = useState([])
    const errorObj = { name: '', datas: '' };
    const format = { rank_id: '', rank_name: '', rank_image: '', mt5_balance_target: '', personal_sale_target: '', group_sale_target: '', commission_type: '', commission_rate: '', contract_commission_type: '', contract_commission: '', same_rank_type: '', same_rank_rate: '', status: '' };
    const [errors, setErrors] = useState([format]);
    const [rankModal, setRankModal] = useState(false);
    const [editRow, setEditRow] = useState('');
    const [img, setImg] = useState(null);
    const [imgPreview, setImgPreview] = useState(null);
    const numFieldName = ['rank_id', 'mt5_balance_target', 'personal_sale_target', 'group_sale_target', 'commission_type', 'commission_rate', 'contract_commission', 'contract_commission_type', 'same_rank_type', 'same_rank_rate', 'status'];
    const [rankForm, setRankForm] = useState({
        rank_id: '',
        rank_name: '',
        rank_image: null,
        mt5_balance_target: '',
        personal_sale_target: '',
        group_sale_target: '',
        commission_type: '',
        commission_rate: '',
        same_rank_type: '',
        same_rank_rate: '',
        status: ''
    })

    useEffect(() => {
        getInfo();
    }, [])

    const getInfo = () => {
        setLoadingData(true)
        fetch(api.get_settings, {
            method: "GET",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang.toLowerCase(),
                "Authorization": "Bearer " + props.auth.auth.access_token
            }),
        })
            .then(response => response.json())
            .then(responseJson => {
                setTimeout(() => {
                    setLoadingData(false);
                }, 1000);
                if (responseJson.status === "success") {
                    let defaultSetting = Object.keys(responseJson.data)
                        .filter(key => key !== settingKey)
                        .reduce((obj, key) => {
                            obj[key] = responseJson.data[key];
                            return obj;
                        }, {});
                    setAllSetting(defaultSetting)
                    convertConfigToNumber(responseJson.data)

                    let currentData = Object.keys(responseJson.data)
                        .filter(key => key === settingKey)
                        .reduce((obj, key) => {
                            obj[key] = responseJson.data[key];
                            return obj;
                        }, {})
                    setInfo(currentData);
                    setFormData(currentData[settingKey].datas[0].value);
                } else {
                    if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                    console.log('error', responseJson.message)
                }
            }).catch(error => {
                console.error("error", error);
            });
    }

    const submitForm = () => {
        let check = true;
        let errorMsg = { ...errorObj };
        let newFormData = deepCopyArray(formData)
        if (formData.length === 0) {
            errorMsg.datas = "This field is required.";
            check = false;
        }
        setErrors(errorMsg)

        if (check) {
            newFormData.map((item, i) => {
                numFieldName.map((field, j) => {
                    newFormData[i][field] = Number(item[field]);
                })
            })
            let uploadPromises = [];
            let popUpMsg = [];
            let newData = deepCopyArray(newFormData);
            newFormData.map((item, i) => {
                if (checkType(item.rank_image) === 'object') {
                    let uploadPromise = new Promise((resolve, reject) => {
                        let form = new FormData();
                        form.append("attachment", item.rank_image);
                        let url = api.upload_rank_image;
                        fetch(url, {
                            method: 'POST',
                            headers: {
                                "Accept-Language": props.lang.toLowerCase(),
                                "Authorization": "Bearer " + props.auth.auth.access_token
                            },
                            body: form,
                        }).then(response => response.json())
                            .then(responseJson => {
                                if (responseJson.status === 'success') {
                                    resolve('done')
                                    newData[i].rank_image = responseJson.data.file_path;
                                } else {
                                    reject('reject');
                                    popUpMsg.push(`rank image ${i} upload fail.`);
                                }
                            })
                            .catch(error => {
                                console.error(error);
                            });

                    })
                    uploadPromises.push(uploadPromise);
                }
            })

            Promise.all(uploadPromises).then(() => {
                proceedUpdate(newData)
            }, (error) => {
                swal(translate(props.lang, "Error"), popUpMsg.join("\n"), "error");
            })
        }
    }

    const proceedUpdate = (data) => {
        setLoading(true);
        let newArr = []
        Object.keys(allSetting).map((item, i) => {
            if (item !== 'config') {
                newArr.push(allSetting[item])
            }
        });
        let newData = info[settingKey];
        newData.datas.map((item) => {
            item.value = data;
        })
        newArr.push(configData)
        newArr.push(newData)
        let newFormData = {
            settings: newArr
        }
        fetch(api.add_settings, {
            method: "POST",
            headers: new Headers({
                "Content-Type": "application/json",
                "Accept-Language": props.lang.toLowerCase(),
                "Authorization": "Bearer " + props.auth.auth.access_token
            }),
            body: JSON.stringify(newFormData)
        })
            .then(response => response.json())
            .then(responseJson => {
                setLoading(false);
                if (responseJson.status === "success") {
                    resetForm();
                    swal(translate(props.lang, "Success"), responseJson.message, { icon: "success" });
                } else {
                    if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                        dispatch(logout(props.history, 'login'));
                    }
                    if (typeof responseJson.data.error === 'object') {
                        let apiErrorMsg = { ...errorObj };
                        let popupMessage = [];
                        Object.keys(responseJson.data.error).map((key, i) => {
                            apiErrorMsg[key] = responseJson.data.error[key];
                            popupMessage.push(responseJson.data.error[key])
                        })
                        setErrors(apiErrorMsg);
                        swal(translate(props.lang, "Error"), popupMessage.join("\n"), "error");
                    } else {
                        swal(translate(props.lang, "Error"), responseJson.message, "error");
                    }
                }
            }).catch(error => {
                console.error("error", error);
            });
    }

    const resetForm = () => {
        getInfo();
    }

    const removeData = (index) => {
        let newList = deepCopyArray(formData);
        newList.splice(index, 1);
        setFormData(newList);
    }

    const handleDataChange = (e) => {
        e.preventDefault();
        const fieldName = e.target.getAttribute('name');
        let fieldValue = e.target.value;
        const newData = { ...rankForm };
        newData[fieldName] = fieldValue;
        setRankForm(newData);
    }

    const handleOptionSelected = (e, field) => {
        let fieldValue = e.value;
        let newFormData = { ...rankForm };
        newFormData[field] = fieldValue;
        setRankForm(newFormData);
    }

    const convertConfigToNumber = (array) => {
        let arr = [];
        configTypeList.map((item) => {
            let filter = array['config'].datas.filter(c => c.key === item.value);
            if (filter.length > 0) {
                if (Array.isArray(filter[0].value)) {
                    filter[0].value = filter[0].value.join(',')
                } else {
                    if (numField.includes(item.value)) {
                        filter[0].value = Number(filter[0].value)
                    }
                }
                arr.push(filter[0])
            }
        })
        let newObject = {
            code: 'config',
            datas: arr,
        }
        newObject.datas.map((item) => {
            if (arrField.includes(item.key)) {
                if (item.value) {
                    item.value = item.value.split(',');
                } else {
                    item.value = [];
                }
            } 
        })
        setConfigData(newObject);
    }

    const resetRankForm = () => {
        setRankForm({ rank_id: '', rank_name: '', rank_image: '', mt5_balance_target: '', personal_sale_target: '', group_sale_target: '', commission_type: '', commission_rate: '', contract_commission_type: '', contract_commission: '', same_rank_type: '', same_rank_rate: '', status: ''})
        setImg(null);
        setImgPreview(null);
    }

    const uploadImage = async (e) => {
        if (e.target.files[0]) {
            let size = (e.target.files[0].size / 1024 / 1024).toFixed(2);
            if (size < 1) {
                let newImg = e.target.files[0];
                let newImgPreview = URL.createObjectURL(e.target.files[0]);
                setImg(newImg)
                setImgPreview(newImgPreview)

            } else {
                swal(translate(props.lang, "Error"), "File too big", "error");
            }
        }
    }

    const closeRankModal = () => {
        setRankModal(false);
        resetRankForm();
    }

    const confirmAddRow = () => {
        let check = true;
        let errorMsg = { ...errorObj }
        let data = { ...rankForm }
        Object.keys(rankForm).map((item) => {
            if (item === 'status') {
                if (!rankForm[item].toString()) {
                    check = false
                    errorMsg[item] = "This field is required";
                }
            } else if (item === 'rank_image') {
                if (!img && !rankForm[item]) {
                    check = false
                    errorMsg['rank_image'] = "This field is required";
                } else {
                    if (img) {
                        if (img !== rankForm[item]) {
                            data.rank_image = img;
                        }
                    }
                }
            } else if (numFieldName.includes(item)) {
                if (!rankForm[item].toString()) {
                    check = false
                    errorMsg[item] = "This field is required";
                } else {
                    if(rankForm[item] < 0){
                        check = false
                        errorMsg[item] = "Value must equal or larger than 0";
                    }
                }
            } else {
                if (!rankForm[item]) {
                    check = false
                    errorMsg[item] = "This field is required";
                }
            }
        })

        if (rankForm.rank_id) {
            formData.map((item, i) => {
                if (i !== Number(editRow)) {
                    if (item.rank_id === rankForm.rank_id) {
                        check = false
                        errorMsg['rank_id'] = "Rank ID has been used";
                    }
                }

            })
        }
        setErrors(errorMsg)
        if (check) {
            let newFormData = deepCopyArray(formData);
            if (editRow && editRow) {
                newFormData[Number(editRow)] = data;
            } else {
                newFormData.push(data);
            }
            setFormData(newFormData);
            closeRankModal();
            setImgPreview(null);
            setImg(null);
            setEditRow(null)
        }
    }

    const editData = (index) => {
        setErrors(errorObj)
        setEditRow(index);
        setRankForm(formData[Number(index)]);
        setRankModal(true)
    }

    const addNewRow = () => {
        let newFormData = { ...rankForm };
        if (formData.length > 0) {
            const largestRankId = Math.max(...formData.map(item => item.rank_id));
            let missingId = [];
            for (let i = 1; i <= largestRankId; i++) {
                let filter = formData.filter(item => Number(item.rank_id) === i);
                if (filter.length === 0) {
                    missingId.push(i);
                }
            }
            if (missingId.length === 0) {
                newFormData.rank_id = Number(largestRankId) + 1;
            } else {
                newFormData.rank_id = missingId[0];
            }
        } else {
            newFormData.rank_id = 1;
        }
        setRankForm(newFormData);
        setRankModal(true)
    }

    return (
        <>
            <div>
                <Row className="px-0 mx-0">
                    <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                        <Table responsive className="w-100 table-list text-center position-relative">
                            <thead>
                                <tr>
                                    <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Rank ID")}</th>
                                    <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Rank Name")}</th>
                                    <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Rank Icon")}</th>
                                    <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "MT5 Balance Target")}</th>
                                    <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Personal Sales Target")}</th>
                                    <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Group Sales Target")}</th>
                                    <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Commission")}</th>
                                    <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Profit Sharing")}</th>
                                    <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Same Rank")}</th>
                                    <th className={`font-weight-600 font-16 text-black text-center`}>{translate(props.lang, "Status")}</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {loadingData ? (
                                    <tr>
                                        <td colSpan={13}>
                                            <LoadingV3 theme='dark' />
                                        </td>
                                    </tr>
                                ) : (
                                    formData.length > 0 ? (
                                        <>
                                            {formData.map((item, i) => (
                                                <tr role="row" className={`${i % 2 === 0 ? 'even' : 'odd'}`}>
                                                    <td className={`font-weight-500 font-16 text-center lh-base`}>{item.rank_id}</td>
                                                    <td className={`font-weight-500 font-16 text-center lh-base`}>{item.rank_name}</td>
                                                    <td className={`font-weight-500 font-16 text-center lh-base`}>{item.rank_image ? (
                                                        checkType(item.rank_image) === 'string' ? (
                                                            <img src={item.rank_image} alt={item.rank_image} className='rank-prev-icon' />
                                                        ) : (
                                                            <img src={URL.createObjectURL(item.rank_image)} alt={item.rank_image} className='rank-prev-icon' />
                                                        )
                                                    ) : null}</td>
                                                    <td className={`font-weight-500 font-16 text-center lh-base`}>{Number(item.mt5_balance_target).toLocaleString('en-US')}</td>
                                                    <td className={`font-weight-500 font-16 text-center lh-base`}>{Number(item.personal_sale_target).toLocaleString('en-US')}</td>
                                                    <td className={`font-weight-500 font-16 text-center lh-base`}>{Number(item.group_sale_target).toLocaleString('en-US')}</td>
                                                    <td className={`font-weight-500 font-16 text-center lh-base`}>{item.commission_rate} {rateTypeList.filter(ct => Number(ct.value) === Number(item.commission_type)).length > 0 ? rateTypeList.filter(ct => Number(ct.value) === Number(item.commission_type))[0].label.toLowerCase() === 'amount' ? "" : "%" : ''}</td>
                                                    <td className={`font-weight-500 font-16 text-center lh-base`}>{item.contract_commission} {rateTypeList.filter(ct => Number(ct.value) === Number(item.contract_commission_type)).length > 0 ? rateTypeList.filter(ct => Number(ct.value) === Number(item.contract_commission_type))[0].label.toLowerCase() === 'amount' ? "" : "%" : ''}</td>
                                                    <td className={`font-weight-500 font-16 text-center lh-base`}>{item.same_rank_rate} {rateTypeList.filter(ct => Number(ct.value) === Number(item.same_rank_type)).length > 0 ? rateTypeList.filter(ct => Number(ct.value) === Number(item.same_rank_type))[0].label.toLowerCase() === 'amount' ? "" : "%" : ''}</td>
                                                    <td className={`font-weight-500 font-16 text-center lh-base`}>{customRankStatus.filter(ct => Number(ct.value) === Number(item.status)).length > 0 ? translate(props.lang, customRankStatus.filter(ct => Number(ct.value) === Number(item.status))[0].label) : ''}</td>
                                                    <td className={`font-weight-500 font-16 text-center lh-base`}>
                                                        <div className="d-flex">
                                                            <div className="px-2" onClick={() => editData(i.toString())}>
                                                                <FaRegEdit color="#244876" size={22} />
                                                            </div>
                                                            <div className="px-2" onClick={() => removeData(i)}>
                                                                <FaTrashAlt color="red" size={22} />
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))}
                                        </>
                                    ) : (
                                        <>
                                            <tr role="row" className={`odd`}>
                                                <td colSpan={13}>
                                                    <div className={`${errors.datas ? 'errorBorder' : ''}`}>
                                                        <NotFound />
                                                    </div>
                                                    <div className="text-start mt-2">
                                                        <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.datas)}</span>
                                                    </div>
                                                </td>
                                            </tr>
                                        </>
                                    )
                                )}
                            </tbody>
                        </Table>
                    </Col>
                    <Col lg={12} sm={12} xs={12} md={12} className="mb-3">
                        <div className='card-light-blue d-block w-100 text-center py-3 cursor-pointer' onClick={() => addNewRow()}>
                            <span className={`font-weight-500 font-16 text-black text-center`}>{translate(props.lang, "Add New Data")}</span>
                        </div>
                    </Col>
                    <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                        <Row className="px-0 mx-0 align-items-stretch">
                            <Col lg={3} md={3} sm={6} xs={6} className='ps-0'>
                                <button className="primary-btn px-4 py-2 text-center mx-auto w-100 h-100" onClick={() => submitForm()} disabled={loading}>
                                    {loading ? <FaSpinner className="fa-spin" color="#fff" /> : (
                                        <span className={`btnText`}>{translate(props.lang, "Update")}</span>
                                    )}
                                </button>
                            </Col>
                            <Col lg={3} md={3} sm={6} xs={6}>
                                <button className="cancel-btn px-4 py-2 text-center mx-auto w-100" onClick={() => resetForm()} disabled={loading}>
                                    <div className='d-flex w-100 justify-content-center align-items-center'>
                                        <span className={`btnText`}>{translate(props.lang, "Cancel")}</span>
                                    </div>
                                </button>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
            <Modal className="fade bgImgModal" size="lg" show={rankModal} centered>
                <Modal.Header className="border-0 pt-4 pb-2 px-3">
                    <div className="d-flex w-100 align-items-center">
                        <div className="w-75"></div>
                        <div className="w-25 text-end cursor-pointer" onClick={() => closeRankModal()} >
                            <svg width="20" height="20" viewBox="0 0 29 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M26 3L3 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                                <path d="M3.00928 3L26.0093 26" stroke="#777777" strokeWidth="5" strokeLinecap="round" />
                            </svg>
                        </div>
                    </div>
                </Modal.Header>
                <Modal.Body className="border-0 px-3">
                    <div className='modalBody px-2 pb-4'>
                        <Row className="justify-content-start px-0 mx-0">
                            <Col lg={12} md={12} sm={12} xs={12} className="px-0 mb-4">
                                <div className="text-center">
                                    <span className="font-weight-600 font-30 text-dark-blue">{editRow ? translate(props.lang, "Edit Rank") : translate(props.lang, "Add Rank")}</span>
                                </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <div className="d-flex w-100 align-items-center">
                                    <span className={`font-weight-500 font-18 text-grey-9`}>{translate(props.lang, "Rank ID")}</span>
                                </div>
                                <div className={`groupLabel-input ${errors.rank_id ? 'errorBorder' : ''}  mt-1 mb-1`}>
                                    <div className="input-group">
                                        <Input
                                            type="number"
                                            placeholder={translate(props.lang, "Enter Rank ID")}
                                            className="form-control input-transparent py-1 px-3"
                                            name="rank_id"
                                            value={rankForm.rank_id}
                                            // onChange={(e) => handleDataChange(e)}
                                            // onWheel={event => event.currentTarget.blur()}
                                            disabled
                                        />
                                    </div>
                                </div>
                                <div>
                                    <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.rank_id)}</span>
                                </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <div className="d-flex w-100 align-items-center">
                                    <span className={`font-weight-500 font-18 text-grey-9`}>{translate(props.lang, "Rank Name")}</span>
                                </div>
                                <div className={`groupLabel-input ${errors.rank_name ? 'errorBorder' : ''}  mt-1 mb-1`}>
                                    <div className="input-group">
                                        <Input
                                            type="text"
                                            placeholder={translate(props.lang, "Enter Rank Name")}
                                            className="form-control input-transparent py-1 px-3"
                                            name="rank_name"
                                            value={rankForm.rank_name}
                                            onChange={(e) => handleDataChange(e)}
                                            onWheel={event => event.currentTarget.blur()}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.rank_name)}</span>
                                </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <div className="d-flex w-100 align-items-center">
                                    <span className={`font-weight-500 font-18 text-grey-9`}>{translate(props.lang, "Rank Image")}</span>
                                </div>
                                <div className={`groupLabel-input py-3 ${errors.rank_image ? 'errorBorder' : ''}  mt-1 mb-1`}>
                                    <label htmlFor="rankImg" className={`mb-0 h-100 w-100 text-center`}>
                                        {imgPreview ? (
                                            <img src={imgPreview} className='rank-prev-icon' alt={rankForm.rank_name} />
                                        ) : rankForm.rank_image ? (
                                            checkType(rankForm.rank_image) === 'string' ? (
                                                <img src={rankForm.rank_image} alt={rankForm.rank_name} className='rank-prev-icon' />
                                            ) : (
                                                <img src={URL.createObjectURL(rankForm.rank_image)} alt={rankForm.rank_name} className='rank-prev-icon' />
                                            )
                                        ) : (
                                            <img src={require('../../../../images/icon/image-upload.png').default} className='add-icon' alt={rankForm.rank_name} />
                                        )}
                                        <span className="font-weight-400 font-14 mt-2 text-grey-9 d-block">{translate(props.lang, "Upload Rank Image")}</span>
                                    </label>
                                    <input type='file' id="rankImg" className="d-none" onChange={(e) => uploadImage(e)} />
                                </div>
                                <div>
                                    <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.rank_image)}</span>
                                </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <div className="d-flex w-100 align-items-center">
                                    <span className={`font-weight-500 font-18 text-grey-9`}>{translate(props.lang, "MT5 Balance Target")}</span>
                                </div>
                                <div className={`groupLabel-input ${errors.rank_name ? 'errorBorder' : ''}  mt-1 mb-1`}>
                                    <div className="input-group">
                                        <Input
                                            type="number"
                                            name="mt5_balance_target"
                                            placeholder={translate(props.lang, "Enter MT5 Balance Target")}
                                            className={`input-transparent py-1 px-3`}
                                            autoComplete="off"
                                            value={rankForm.mt5_balance_target}
                                            onChange={(e) => handleDataChange(e)}
                                            onWheel={event => event.currentTarget.blur()}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.mt5_balance_target)}</span>
                                </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <div className="d-flex w-100 align-items-center">
                                    <span className={`font-weight-500 font-18 text-grey-9`}>{translate(props.lang, "Personal Sales Target")}</span>
                                </div>
                                <div className={`groupLabel-input ${errors.personal_sale_target ? 'errorBorder' : ''}  mt-1 mb-1`}>
                                    <div className="input-group">
                                        <Input
                                            type="number"
                                            placeholder={translate(props.lang, "Enter Personal Sales Target")}
                                            className="form-control input-transparent py-1 px-3"
                                            name="personal_sale_target"
                                            autoComplete="off"
                                            value={rankForm.personal_sale_target}
                                            onChange={(e) => handleDataChange(e)}
                                            onWheel={event => event.currentTarget.blur()}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.personal_sale_target)}</span>
                                </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <div className="d-flex w-100 align-items-center">
                                    <span className={`font-weight-500 font-18 text-grey-9`}>{translate(props.lang, "Group Sales Target")}</span>
                                </div>
                                <div className={`groupLabel-input ${errors.group_sale_target ? 'errorBorder' : ''}  mt-1 mb-1`}>
                                    <div className="input-group">
                                        <Input
                                            type="number"
                                            placeholder={translate(props.lang, "Enter Group Sales Target")}
                                            className="form-control input-transparent py-1 px-3"
                                            name="group_sale_target"
                                            value={rankForm.group_sale_target}
                                            autoComplete="off"
                                            onChange={(e) => handleDataChange(e)}
                                            onWheel={event => event.currentTarget.blur()}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.group_sale_target)}</span>
                                </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <div className="d-flex w-100 align-items-center">
                                    <span className={`font-weight-500 font-18 text-grey-9`}>{translate(props.lang, "Commission")}</span>
                                </div>
                                <Row className="px-0 mx-0">
                                    <Col lg={6} md={6} sm={6} xs={6} className="ps-0 pe-1">
                                        <div className={`groupLabel-input ${errors.commission_rate ? 'errorBorder' : ''}  mt-1 mb-1`}>
                                            <div className="input-group">
                                                <Input
                                                    type="number"
                                                    placeholder={translate(props.lang, "Enter Rate")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    name="commission_rate"
                                                    value={rankForm.commission_rate}
                                                    autoComplete="off"
                                                    onChange={(e) => handleDataChange(e)}
                                                    onWheel={event => event.currentTarget.blur()}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.commission_rate)}</span>
                                        </div>
                                    </Col>
                                    <Col lg={6} md={6} sm={6} xs={6} className="ps-1 pe-0">
                                        <div className={`input-group-select mt-1 mb-1 ${errors.commission_type ? 'errorBorder' : ''}`}>
                                            <div className="d-flex align-items-center">
                                                <Select
                                                    options={
                                                        rateTypeList.length > 0 ? rateTypeList.map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                    }
                                                    placeholder={translate(props.lang, "Select Type")}
                                                    className="input-transparent w-100 text-capitalize"
                                                    styles={customSelectStyles}
                                                    classNamePrefix="customSelect"
                                                    value={
                                                        rankForm.commission_type ? (
                                                            rateTypeList.filter(item => item.value == rankForm.commission_type).length > 0 ?
                                                                (rateTypeList.filter(item => item.value == rankForm.commission_type).map((item, i) => ({ value: item.value, label: translate(props.lang, item.label), key: i })))
                                                                : null
                                                        ) : null
                                                    }
                                                    onChange={(e) => handleOptionSelected(e, "commission_type")}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.commission_type)}</span>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <div className="d-flex w-100 align-items-center">
                                    <span className={`font-weight-500 font-18 text-grey-9`}>{translate(props.lang, "Contract Commission")}</span>
                                </div>
                                <Row className="px-0 mx-0">
                                    <Col lg={6} md={6} sm={6} xs={6} className="ps-0 pe-1">
                                        <div className={`groupLabel-input ${errors.contract_commission ? 'errorBorder' : ''}  mt-1 mb-1`}>
                                            <div className="input-group">
                                                <Input
                                                    type="number"
                                                    placeholder={translate(props.lang, "Enter Rate")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    name="contract_commission"
                                                    value={rankForm.contract_commission}
                                                    autoComplete="off"
                                                    onChange={(e) => handleDataChange(e)}
                                                    onWheel={event => event.currentTarget.blur()}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.contract_commission)}</span>
                                        </div>
                                    </Col>
                                    <Col lg={6} md={6} sm={6} xs={6} className="ps-1 pe-0">
                                        <div className={`input-group-select mt-1 mb-1 ${errors.contract_commission_type ? 'errorBorder' : ''}`}>
                                            <div className="d-flex align-items-center">
                                                <Select
                                                    options={
                                                        rateTypeList.length > 0 ? rateTypeList.map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                    }
                                                    placeholder={translate(props.lang, "Select Type")}
                                                    className="input-transparent w-100 text-capitalize"
                                                    styles={customSelectStyles}
                                                    classNamePrefix="customSelect"
                                                    value={
                                                        rankForm.contract_commission_type ? (
                                                            rateTypeList.filter(item => item.value == rankForm.contract_commission_type).length > 0 ?
                                                                (rateTypeList.filter(item => item.value == rankForm.contract_commission_type).map((item, i) => ({ value: item.value, label: translate(props.lang, item.label), key: i })))
                                                                : null
                                                        ) : null
                                                    }
                                                    onChange={(e) => handleOptionSelected(e, "contract_commission_type")}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.contract_commission_type)}</span>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <div className="d-flex w-100 align-items-center">
                                    <span className={`font-weight-500 font-18 text-grey-9`}>{translate(props.lang, "Same Rank")}</span>
                                </div>
                                <Row className="px-0 mx-0">
                                    <Col lg={6} md={6} sm={6} xs={6} className="ps-0 pe-1">
                                        <div className={`groupLabel-input ${errors.same_rank_rate ? 'errorBorder' : ''}  mt-1 mb-1`}>
                                            <div className="input-group">
                                                <Input
                                                    type="number"
                                                    placeholder={translate(props.lang, "Enter Rate")}
                                                    className="form-control input-transparent py-1 px-3"
                                                    name="same_rank_rate"
                                                    value={rankForm.same_rank_rate}
                                                    autoComplete="off"
                                                    onChange={(e) => handleDataChange(e)}
                                                    onWheel={event => event.currentTarget.blur()}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.same_rank_rate)}</span>
                                        </div>
                                    </Col>
                                    <Col lg={6} md={6} sm={6} xs={6} className="ps-1 pe-0">
                                        <div className={`input-group-select mt-1 mb-1 ${errors.same_rank_type ? 'errorBorder' : ''}`}>
                                            <div className="d-flex align-items-center">
                                                <Select
                                                    options={
                                                        rateTypeList.length > 0 ? rateTypeList.map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                    }
                                                    placeholder={translate(props.lang, "Select Type")}
                                                    className="input-transparent w-100 text-capitalize"
                                                    styles={customSelectStyles}
                                                    classNamePrefix="customSelect"
                                                    value={
                                                        rankForm.same_rank_type ? (
                                                            rateTypeList.filter(item => item.value == rankForm.same_rank_type).length > 0 ?
                                                                (rateTypeList.filter(item => item.value == rankForm.same_rank_type).map((item, i) => ({ value: item.value, label: translate(props.lang, item.label), key: i })))
                                                                : null
                                                        ) : null
                                                    }
                                                    onChange={(e) => handleOptionSelected(e, "same_rank_type")}
                                                />
                                            </div>
                                        </div>
                                        <div>
                                            <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.same_rank_type)}</span>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <div className="d-flex w-100 align-items-center">
                                    <span className={`font-weight-500 font-18 text-grey-9`}>{translate(props.lang, "Status")}</span>
                                </div>
                                <div className={`input-group-select mt-1 mb-1 ${errors.status ? 'errorBorder' : ''}`}>
                                    <div className="d-flex align-items-center">
                                        <Select
                                            options={
                                                customRankStatus.length > 0 ? customRankStatus.map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                            }
                                            placeholder={translate(props.lang, "Select Status")}
                                            className="input-transparent w-100 text-capitalize"
                                            styles={customSelectStyles}
                                            isSearchable={false}
                                            classNamePrefix="customSelect"
                                            value={
                                                rankForm.status ? (
                                                    customRankStatus.filter(item => item.value.toString() == rankForm.status.toString()).length > 0 ?
                                                        (customRankStatus.filter(item => item.value.toString() == rankForm.status.toString()).map((item, i) => ({ value: item.value, label: translate(props.lang, item.label), key: i })))
                                                        : null
                                                ) : null
                                            }
                                            onChange={(e) => handleOptionSelected(e, "status")}
                                        />
                                    </div>
                                </div>
                                <div>
                                    <span className="font-weight-400 font-14 errorTextRed">{translate(props.lang, errors.status)}</span>
                                </div>
                            </Col>
                            <Col lg={12} md={12} sm={12} xs={12} className="mt-3 px-0">
                                <Row className="px-0 mx-0">
                                    <Col lg={6} md={6} sm={6} xs={6} className="ps-0">
                                        <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => confirmAddRow()}>
                                            <span className={`btnText`}>{translate(props.lang, "Confirm")}</span>
                                        </button>
                                    </Col>
                                    <Col lg={6} md={6} sm={6} xs={6} className="pe-0">
                                        <button className="cancel-btn px-4 py-2 text-center mx-auto w-100" onClick={() => resetRankForm()}>
                                            <span className={`btnText`}>{translate(props.lang, "Reset")}</span>
                                        </button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}
const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(Rank);